import {
  Button,
  FormControl,
  Heading,
  Input,
  Stack,
  useColorModeValue,
  Link,
  Stat,
  StatHelpText,
  StatLabel,
  Image,
  VStack,
  HStack,
  useToast,
  Spinner,
} from '@chakra-ui/react'
import { useState } from 'react'
import {
  useAccount,
  useContractRead,
  useContractWrite,
  usePrepareContractWrite,
  useWaitForTransaction,
} from 'wagmi'
import { useDebounce } from '../hooks'
import SimpleStorageABI from '../assets/constants/abi/SimpleStorage.json'
import NetworkMapping from '../assets/constants/network-mapping.json'

import MessageSvg from '../assets/message.svg'
import { GistDisplay } from '../components'
export default function SimpleStorage() {
  const [text, setText] = useState('')
  const debouncedText = useDebounce(text, 500)
  const { isDisconnected } = useAccount()
  const toast = useToast()
  const { data: textData } = useContractRead({
    address: NetworkMapping['80001']['SimpleStorage'] as `0x${string}`,
    abi: SimpleStorageABI,
    functionName: 'getData',
    watch: true,
  })

  const {
    config,
    error: prepareError,
    isError: isPrepareError,
  } = usePrepareContractWrite({
    address: NetworkMapping['80001']['SimpleStorage'] as `0x${string}`,
    abi: SimpleStorageABI,
    functionName: 'setData',
    args: [debouncedText],
    enabled: Boolean(debouncedText),
  })

  const { data, error, isError, write } = useContractWrite(config)

  const { isLoading } = useWaitForTransaction({
    hash: data?.hash,
    onSuccess(data) {
      setText('')
      toast({
        position: 'bottom-right',
        duration: 6000,
        render: () => (
          <Stat bgColor={'brand.50'} py={'3'} px={'8'} borderRadius={'lg'}>
            <StatLabel>Message Updated Successfully</StatLabel>
            <StatHelpText>
              {data && (
                <Link
                  href={`https://mumbai.polygonscan.com/tx/${data?.transactionHash}`}
                  target="_blank"
                >
                  View Transaction
                </Link>
              )}
            </StatHelpText>
          </Stat>
        ),
      })
    },
  })

  return (
    <VStack
      spacing={{ base: '30px' }}
      minH={{ base: '80vh', md: '80vh' }}
      wrap={'wrap'}
      align={'center'}
      justify={'center'}
      mb={'10px'}
    >
      <HStack
        minH={{ base: '80vh', md: '80vh' }}
        wrap={'wrap'}
        align={'center'}
        justify={'center'}
        mb={'10px'}
      >
        <Image src={MessageSvg} boxSize={{ base: '200px', md: 'sm' }}></Image>
        <Stack
          spacing={4}
          bg={useColorModeValue('white', 'gray.700')}
          rounded={'xl'}
          boxShadow={'lg'}
          p={{ base: '12', md: '12' }}
          my={{ base: '6', md: '12' }}
        >
          <Heading
            lineHeight={1.5}
            fontSize={{ base: '2xl', md: '4xl' }}
            color={'brand.500'}
            alignSelf={'center'}
          >
            Bill Board 🖼️
          </Heading>

          <Heading
            lineHeight={1.2}
            fontSize={{ base: '2xl', md: '3xl' }}
            color={'second.500'}
            alignSelf={'center'}
          >
            {`${textData}`}
          </Heading>
          <FormControl id="email">
            <Input
              placeholder="Enter New Message"
              _placeholder={{ color: 'gray.500' }}
              type="text"
              onChange={(e) => setText(e.target.value)}
              value={text}
            />
          </FormControl>
          <Stack spacing={6}>
            <Button
              bg={'brand.500'}
              color={'white'}
              _disabled={{
                bg: 'gray.600',
                cursor: 'not-allowed',
              }}
              _hover={{
                bg: 'brand.600',
              }}
              onClick={(e) => {
                e.preventDefault()
                write?.()
              }}
              isDisabled={!write || isLoading || !text}
            >
              {isLoading && <Spinner size="sm" thickness="2px" color="white" mx={'3px'} />}
              {isDisconnected ? 'Wallet Not Connected' : isLoading ? 'Updating...' : 'Update Board'}
            </Button>
            {(isPrepareError || isError) && <div>Error: {(prepareError || error)?.message}</div>}
          </Stack>
        </Stack>
      </HStack>

      <GistDisplay id={'f09f0bff7f354ed8763db296a6912976'} />
    </VStack>
  )
}
